import {
    IProps,
} from './types';

import classNames from 'classnames';
import {
    formatAmount,
} from 'helpers';
import React, {
    FC,
} from 'react';

import styles from './AmountCard.module.scss';

const AmountCard: FC<IProps> = (props) => {
    return (
        <div className={classNames(styles.amountCard, props.className)}>
            <div className={styles.title}>
                Paid Amount
            </div>
            <div className={styles.amount}>
                {`${props.currencySymbol}${formatAmount(props.amountKopecks)}`}
            </div>
        </div>
    );
};

export default AmountCard;
